/** Lot 2B — pages d'information publiques (Preview). BROUILLON : ne vaut pas déclaration de conformité ni texte prêt à publier. */
import { Link } from "react-router-dom";

export function LegalShell({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-[color:var(--cf-bg-2)] text-slate-900" data-testid={testid}>
      <header className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="text-[11px] font-extrabold tracking-[0.12em] uppercase text-slate-500">Crédit Flow</div>
          <nav className="flex gap-4 text-[12px] font-bold">
            <Link to="/mentions-legales" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-mentions">Mentions légales</Link>
            <Link to="/confidentialite" className="text-slate-600 hover:text-slate-900" data-testid="legal-nav-confidentialite">Confidentialité</Link>
          </nav>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-8">
        <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 mb-6 text-[12px] text-amber-900" data-testid="legal-draft-banner">
          <strong>Brouillon Preview — non publié.</strong> Les éléments signalés « À confirmer avant publication » n'ont pas été vérifiés contractuellement. Cette page ne constitue pas une déclaration de conformité.
        </div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-1">{title}</h1>
        {subtitle && <p className="text-[13px] text-slate-500 mb-8">{subtitle}</p>}
        <div className="space-y-8">{children}</div>
        <p className="text-[11px] text-slate-400 mt-10">Dernière mise à jour du brouillon : juin 2026.</p>
      </main>
    </div>
  );
}

export function Section({ title, children, testid }) {
  return (
    <section data-testid={testid}>
      <h2 className="text-base md:text-lg font-extrabold mb-2">{title}</h2>
      <div className="text-[14px] leading-relaxed text-slate-700 space-y-2">{children}</div>
    </section>
  );
}

export function ToConfirm({ children }) {
  return (
    <div className="rounded-lg border border-dashed border-amber-400 bg-amber-50/60 px-3 py-2 text-[12.5px] text-amber-900" data-testid="legal-to-confirm">
      <span className="font-extrabold">À confirmer avant publication :</span> {children}
    </div>
  );
}
